<!--SUSCRITO-->
<!--PARTE 2 DESCRIPCION --- COMPONENTE  -->

<div class="mx-auto max-w-7xl w-full md:py-8  flex flex-col lg:flex-row gap-8">

  <!-- ===== LEFT COLUMN: Description + Timeline ===== -->
  <div class="flex-1 min-w-0">

    <!-- Description card -->
    <div class=" bg-white md:border md:border-border/60 md:rounded-lg p-6 shadow-sm py-6 md:mb-6">
      <h2 class="text-lg font-semibold text-gray-700 mb-3 inline-block relative group cursor-pointer">
        {{'words.description' | translate}}
        <span
          class="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-secondary transition-all duration-300 ease-out group-hover:w-full"></span>
      </h2>

      <div class="journey-description-summary">
        <p readMore #descReadMore="readMore" class="inner-html"
          [innerHTML]="journey.description ? (journey.description | safe:'html') : ('words.undescribed-content' | translate)">
        </p>
      </div>
      <a class="text-gray-400 text-sm cursor-pointer" *ngIf="descReadMore.overflow"
        (click)="descReadMore.toggleExtend()">{{
        'words.read-more.' + descReadMore.extended | translate }} <span><i class="icon icon-arrow-ios-down"
            [class.icon-arrow-ios-up]="descReadMore.extended"
            [class.icon-arrow-ios-down]="!descReadMore.extended"></i></span></a>

    </div>

    <div class="w-px h-26 bg-gray-200 shrink-0 hidden md:block"></div>

    <!-- Timeline — solo si está suscrito -->
    <ng-container>
      <div class="flex gap-2.5 mx-4 md:mx-0 pt-8 md:pt-0 flex-row">
        <div class="w-1.5 h-6 rounded-full bg-secondary"></div>
        <h3 class="text-lg font-semibold mb-4 text-gray-700">{{'words.traject' | translate}}</h3>
      </div>
      <!-- TIMELINE -->
      <div class="flex flex-col gap-4">
        <ng-container *ngFor="let content of journey.contents; let index=index">
        <ng-container *ngIf="!content.isSkeleton; else summaryItemSkeletonTpl">

          <!-- ===== DESKTOP CARD (md+) ===== -->
          <article
            class="hidden md:flex bg-white rounded-lg border border-border/50 p-5 gap-5 items-center shadow-sm"
            [ngClass]="{'opacity-60': content.isLocked || journey.isLocked}">

          <div class="relative w-36 h-28 shrink-0 rounded-lg overflow-hidden bg-muted">
            <img [src]="getContentPicture(content)" [alt]="content.data?.title || ''"
              class="block-module__image w-full h-full object-cover"
              [ngClass]="{'opacity-50': !journey.subscribed}">
            <msc-tag [text]="getType(content) | translate"
              class="absolute top-2 left-2 text-[10px] font-semibold px-1.5 py-0.5 rounded-xl text-white/80 backdrop-blur-sm group-hover:opacity-0 transition-opacity duration-300 bg-black/30"></msc-tag>
            <div class="absolute inset-0 bg-foreground/30"></div>
          </div>

          <div class="flex-1 min-w-0">
            <h4 class="text-md font-semibold text-gray-700 leading-snug mb-1.5">
              {{ content.data?.title || ('words.untitled' | translate) }}
            </h4>
            <div class="journey-description-summary-leccion">
              <p class="text-sm font-normal text-gray-500 leading-relaxed mb-2.5 line-clamp-2"
                *ngIf="content.data?.description" [innerHTML]="content.data.description | safe:'html'">
              </p>
            </div>
            <div class="flex items-center gap-3 text-xs flex-wrap mt-1">

              <!-- Course: all resume stats -->
              <ng-container *ngIf="content.context === 'course' && content.data?.resume">
                <span class="flex items-center gap-1 text-gray-500 font-normal text-sm "
                  [tooltip]="'stats.content.type-media' | translate" *ngIf="content.data.resume.media">
                  <i class="icon icon-play-circle text-xs"></i>{{ content.data.resume.media }}
                </span>
                <span class="flex items-center gap-1 text-gray-500 font-normal text-sm "
                  [tooltip]="'stats.content.type-exchange' | translate" *ngIf="content.data.resume.exchange">
                  <i class="icon icon-message-circle text-xs"></i>{{ content.data.resume.exchange }}
                </span>
                <span class="flex items-center gap-1 text-gray-500 font-normal text-sm "
                  [tooltip]="'stats.content.type-cheatsheet' | translate" *ngIf="content.data.resume.cheatsheet">
                  <i class="icon icon-file-text text-xs"></i>{{ content.data.resume.cheatsheet }}
                </span>
                <span class="flex items-center gap-1 text-gray-500 font-normal text-sm "
                  [tooltip]="'stats.content.type-exercise' | translate" *ngIf="content.data.resume.exercise">
                  <i class="icon icon-checkmark-square text-xs"></i>{{ content.data.resume.exercise }}
                </span>
                <span class="flex items-center gap-1 text-gray-500 font-normal text-sm "
                  [tooltip]="'stats.content.type-certificate' | translate" *ngIf="content.data.resume.certificate">
                  <i class="icon icon-award text-xs"></i>{{ content.data.resume.certificate }}
                </span>
                <span class="flex items-center gap-1 text-gray-500 font-normal text-sm "
                  [tooltip]="'stats.content.type-project' | translate" *ngIf="content.data.resume.project">
                  <i class="icon icon-clipboard text-xs"></i>{{ content.data.resume.project }}
                </span>
                <span class="flex items-center gap-1 text-gray-500 font-normal text-sm "
                  [tooltip]="'stats.content.type-event' | translate" *ngIf="content.data.resume.event">
                  <i class="icon icon-calendar text-xs"></i>{{ content.data.resume.event }}
                </span>
              </ng-container>

              <!-- Duration -->
              <span class="flex items-center gap-1.5 text-muted-foreground" *ngIf="content.session?.duration">
                <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                {{ content.session.duration | duration }}
              </span>

              <!-- Individual activity type badge -->
              <ng-container *ngIf="content.context === 'content'">
                <span *ngIf="content.data?.context === 'media'"
                  class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 font-medium">
                  <i class="icon icon-play-circle text-xs"></i>
                  {{ 'stats.content.type-media' | translate }}
                </span>
                <span *ngIf="content.data?.context === 'exchange'"
                  class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-100 text-green-700 font-medium">
                  <i class="icon icon-message-circle text-xs"></i>
                  {{ 'stats.content.type-exchange' | translate }}
                </span>
                <span *ngIf="content.data?.context === 'cheatsheet'"
                  class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-purple-100 text-purple-700 font-medium">
                  <i class="icon icon-file-text text-xs"></i>
                  {{ 'stats.content.type-cheatsheet' | translate }}
                </span>
                <span *ngIf="content.data?.context === 'exercise'"
                  class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-orange-100 text-orange-700 font-medium">
                  <i class="icon icon-checkmark-square text-xs"></i>
                  {{ 'stats.content.type-exercise' | translate }}
                </span>
              </ng-container>

            </div>
          </div>

          <!-- Separador Vertical -->
          <div class="w-px self-stretch my-3 bg-gray-200"></div>

          <div class="flex flex-col items-center gap-2.5 shrink-0 px-2">
            <!-- Mientras se resuelve el estado real de bloqueo/suscripción, un skeleton
                 en vez del candado: evitaba que apareciera el candado y desapareciera
                 de golpe al llegar la respuesta para un usuario suscrito. -->
            <ng-container *ngIf="journey.lockStatePending; else resolvedProgressLockDesktop">
              <div class="w-14 h-14 rounded-full bg-gray-200 animate-pulse shrink-0"></div>
              <div class="h-7 w-20 rounded-full bg-gray-200 animate-pulse"></div>
            </ng-container>
            <ng-template #resolvedProgressLockDesktop>
              <ng-container *ngIf="journey.subscribed && !content.isLocked && !journey.isLocked; else lockedTplDesktop">
                <div class="relative shrink-0 w-14 h-14">
                  <svg class="w-full h-full -rotate-90" viewBox="0 0 56 56">
                    <defs>
                      <linearGradient id="ring-grad-journey" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" style="stop-color: var(--v2-color-primary-500)" />
                        <stop offset="80%" style="stop-color: var(--v2-color-primary-500)" />
                        <stop offset="100%" style="stop-color: var(--v2-color-primary-500)" />
                      </linearGradient>
                    </defs>
                    <circle cx="28" cy="28" r="23" stroke="#e5e7eb" stroke-width="4" fill="none" />
                    <circle cx="28" cy="28" r="23" stroke="url(#ring-grad-journey)" stroke-width="4" fill="none"
                      stroke-linecap="round" [attr.stroke-dasharray]="144.5"
                      [attr.stroke-dashoffset]="144.5 - ((content?.session?.progress || 0) * 144.5 / 100)"
                      class="transition-all duration-300 ease-in-out" />
                  </svg>
                  <div class="absolute inset-0 flex items-center justify-center">
                    <span class="text-[10px] font-bold leading-none text-gray-700">
                      {{ content?.session?.progress || 0 }}%
                    </span>
                  </div>
                </div>
                <button *ngIf="journey.subscribed"
                  class="text-xs font-semibold text-white bg-primary-700 px-6 py-2 rounded-full hover:opacity-90 transition-all whitespace-nowrap"
                  [ngClass]="{'pointer-events-none opacity-60': contentIdLoading === content.data?.id}"
                  (click)="executeContent(content)">
                  {{ contentIdLoading === content.data?.id ? ('words.course-loading' | translate) + '...' :
                  getTranslateButton(content) }}
                </button>
              </ng-container>
              <ng-template #lockedTplDesktop>
                <i class="icon icon-lock text-gray-400 text-xl"></i>
              </ng-template>
            </ng-template>
          </div>

          </article>

          <!-- ===== MOBILE CARD (< md) ===== -->
          <article
            class="content-ruta-sumary mx-4 flex md:hidden bg-white rounded-xl border border-border/50 shadow-sm overflow-hidden transition-all duration-200"
            [ngClass]="{
              'opacity-60': content.isLocked || journey.isLocked,
              'cursor-pointer hover:shadow-md hover:border-primary/40 active:scale-[0.99]': journey.subscribed && !content.isLocked && !journey.isLocked && !journey.lockStatePending
            }"
            (click)="journey.subscribed && !content.isLocked && !journey.isLocked && !journey.lockStatePending && executeContent(content)">

            <!-- Thumbnail cuadrado pequeño -->
            <div class="relative w-14 h-14 shrink-0 bg-muted self-center ml-3 rounded-lg overflow-hidden">
              <img [src]="getContentPicture(content)" [alt]="content.data?.title || ''"
                class="w-full h-full object-cover"
                [ngClass]="{'opacity-50': !journey.subscribed}">
              <div class="absolute inset-0 transition-all duration-200"
                [ngClass]="!journey.subscribed ? 'bg-foreground/50' : 'bg-foreground/20'"></div>
            </div>

            <!-- Body: una sola columna -->
            <div class="flex-1 min-w-0 px-3 py-3 flex flex-col justify-center ">
              <!-- Título -->
              <h4 class="text-sm font-semibold text-gray-800 leading-snug line-clamp-1">
                {{ content.data?.title || ('words.untitled' | translate) }}
              </h4>
              <!-- Provider / categoria -->
              <p class="text-xs text-gray-500 font-normal truncate">
                {{ content.data?.provider?.name || ('api.content-type.course' | translate) }}
              </p>

              <!-- Mientras se resuelve el estado real de bloqueo/suscripción: skeleton
                   en vez del candado, para no mostrar el candado y quitarlo de golpe. -->
              <div *ngIf="journey.lockStatePending" class="flex items-center gap-2 mt-1">
                <div class="h-3 flex-1 rounded bg-gray-200 animate-pulse"></div>
                <div class="h-6 w-16 shrink-0 rounded-full bg-gray-200 animate-pulse"></div>
              </div>

              <!-- Si está suscrito y no bloqueado: progreso + botón -->
              <ng-container *ngIf="!journey.lockStatePending && journey.subscribed && !content.isLocked && !journey.isLocked">
                <div class="flex items-center gap-2 ">
                  <div class="flex-1 flex flex-col gap-0.5">
                    <span class="text-[10px] text-primary-700 font-medium">
                      {{ content?.session?.progress || 0 }}% {{'words.progress_1' | translate}}
                    </span>
                    <div class="hidden h-1.5 bg-gray-100 rounded-full overflow-hidden w-full">
                      <div class="h-full rounded-full bg-secondary transition-all duration-300"
                        [style.width]="(content?.session?.progress || 0) + '%'"></div>
                    </div>
                  </div>
                  <button
                    class="shrink-0 text-[10px] font-semibold text-white bg-primary px-3 py-1.5 rounded-full hover:opacity-90 transition-all whitespace-nowrap"
                    [ngClass]="{'pointer-events-none opacity-60': contentIdLoading === content.data?.id}"
                    (click)="executeContent(content)">
                    {{ contentIdLoading === content.data?.id ? ('words.course-loading' | translate) + '...' :
                getTranslateButton(content) }}
                  </button>
                </div>
              </ng-container>

              <!-- Si NO está suscrito: descripción corta + candado -->
              <ng-container *ngIf="!journey.lockStatePending && !journey.subscribed && !content.isLocked && !journey.isLocked">
                <div class="flex items-center gap-2 mt-1">
                  <p class="flex-1 text-[10px] text-gray-400 leading-snug line-clamp-2"
                    *ngIf="content.data?.description"
                    [innerHTML]="content.data.description | safe:'html'">
                  </p>
                  <span *ngIf="!content.data?.description" class="flex-1 text-[10px] text-gray-400 italic">
                    {{ 'words.undescribed-content' | translate }}
                  </span>
                  <i class="icon icon-lock text-gray-400 text-xl shrink-0"></i>
                </div>
              </ng-container>
            </div>

            <!-- Candado derecha — solo si está bloqueado (y suscrito) -->
            <div *ngIf="journey.subscribed && (content.isLocked || journey.isLocked)"
              class="shrink-0 flex items-center justify-center pr-4 pl-2">
              <i class="icon icon-lock text-gray-400 text-xl"></i>
            </div>

          </article>

        </ng-container>

        <!-- Skeleton de un ítem mientras journey.contents todavía trae placeholders
             (isSkeleton: true, ver JourneyProvider.skeletonJourney()) -->
        <ng-template #summaryItemSkeletonTpl>
          <article class="hidden md:flex bg-white rounded-lg border border-border/50 p-5 gap-5 items-center shadow-sm animate-pulse">
            <div class="w-36 h-28 shrink-0 rounded-lg bg-gray-200"></div>
            <div class="flex-1 min-w-0 flex flex-col gap-2">
              <div class="h-4 w-2/3 rounded bg-gray-200"></div>
              <div class="h-3 w-1/3 rounded bg-gray-200"></div>
            </div>
            <div class="w-14 h-14 rounded-full bg-gray-200 shrink-0"></div>
          </article>
          <article class="content-ruta-sumary mx-4 flex md:hidden bg-white rounded-xl border border-border/50 shadow-sm overflow-hidden animate-pulse">
            <div class="w-14 h-14 shrink-0 bg-gray-200 self-center ml-3 rounded-lg"></div>
            <div class="flex-1 min-w-0 px-3 py-3 flex flex-col gap-2 justify-center">
              <div class="h-4 w-2/3 rounded bg-gray-200"></div>
              <div class="h-3 w-1/3 rounded bg-gray-200"></div>
            </div>
          </article>
        </ng-template>

        </ng-container>

        <msc-common-spinner *ngIf="journeyContentLoading"></msc-common-spinner>
      </div>
      <div class="w-full flex justify-center items-center mt-4" *ngIf="!isLimitReached">
        <msc-button class="btn btn--primary" (click)="loadMore()" *ngIf="!loadingMore">
          {{ 'words.load-more' | translate }}
        </msc-button>
        <msc-common-spinner *ngIf="loadingMore"></msc-common-spinner>
      </div>

    </ng-container>

    <!-- Placeholder cuando NO está suscrito -->
    <ng-template #notSubscribedTimeline>
      <div
        class="flex flex-col items-center justify-center gap-3 py-12 rounded-2xl border border-dashed border-border/60 bg-muted/30">
        <div class="w-12 h-12 rounded-full bg-muted flex items-center justify-center">
          <i class="icon icon-lock text-xl text-muted-foreground"></i>
        </div>
        <p class="text-sm font-semibold text-gray-700">{{'words.traject' | translate}}</p>
        <p class="text-xs text-muted-foreground text-center max-w-xs">{{ 'words.subscribe' | translate }} {{'words.to' |
          translate | lowercase}} {{'words.access-content' | translate | lowercase}}</p>
      </div>
    </ng-template>

  </div>


  <!-- ===== RIGHT ASIDE: Course details + Provider ===== -->
  <aside class="w-full lg:w-[300px] shrink-0">

    <!-- Course details card -->
    <div class="mx-4 md:mx-0  bg-white rounded-xl border border-gray-100 shadow-md overflow-hidden">
      <div class="p-5 flex flex-col gap-3">

        <h4 class="text-lg font-bold text-gray-700">{{'words.course-details' | translate}}</h4>
        <hr class="border-gray-200" />

        <!-- Details -->
        <div class="flex flex-col gap-2 text-sm text-gray-500">
          <div class="flex items-center gap-2.5">
            <i class="fa-regular fa-clock text-gray-400"></i>
            <span>{{ convertSecondsToHoursMinutes(journey.duration) }} </span>
          </div>
          <div class="flex items-center gap-2.5">
            <i class="fa-solid fa-earth-americas text-gray-400"></i>
            <span>{{ journey?.language?.name }}</span>
          </div>
          <div class="flex items-center gap-2.5" *ngIf="journey?.type">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="w-4 h-4 shrink-0">
              <path d="M12 7v14"></path>
              <path
                d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z">
              </path>
            </svg>
            <span>{{ 'type.' + journey.type | translate }}</span>
          </div>
          <div class="flex items-center gap-2.5" *ngIf="journey?.isCertifiable">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="w-4 h-4 text-gray-400 shrink-0">
              <path
                d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526">
              </path>
              <circle cx="12" cy="8" r="6"></circle>
            </svg>
            <span>{{'words.is-certificable' | translate}}</span>
          </div>
        </div>

        <!-- Subscribe button -->
        <button
          class="w-full py-2.5 rounded-full text-sm font-semibold bg-primary text-white hover:bg-secondary-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          palette="secondary" [disabled]="!journey.subscribable"
          *ngIf="!courseSessionFull && !journeyIsFull && !journey.subscribed" (click)="subscribeRequested.emit()">
          <span class="text-sm font-semibold px-2">{{ 'words.subscribe' | translate }}</span>
        </button>

        <!-- Unsubscribe button -->
        <button *ngIf="journey.subscribed"
          class="w-full shadow-sm py-2 rounded-full hover:shadow-md text-sm text-gray-600 border border-gray-500 hover:bg-gray-200 transition-colors flex items-center justify-center gap-2 hover:text-gray-700"
          palette="danger" (click)="unsubscribeRequested.emit(journey.title)">
          {{ "words.unsubscribe" | translate }}
        </button>

        <!-- Contact us button -->
        <button
          class="w-full py-2.5 rounded-full text-sm font-semibold bg-primary text-white hover:bg-secondary-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          palette="secondary" [loading]="sendingMessage" *ngIf="courseSessionFull || journeyIsFull"
          (click)="contactUsRequested.emit()" [disabled]="sendingMessage">
          {{ 'words.contact-us' | translate }}
        </button>

        <hr class="border-gray-200" />

        <!-- Actions: Rate / Save -->
        <div class="flex justify-around pt-1">
          <button *ngIf="journey.subscribed" (click)="rateRequested.emit()"
            class="flex flex-col items-center gap-1 text-gray-400 hover:text-yellow-500 text-[10px] uppercase font-bold transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="w-4 h-4 text-gray-500">
              <path
                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
              </path>
            </svg>
            <span class="text-gray-500 text-[10px] font-medium uppercase tracking-wide">Calificar</span>
          </button>
          <div *ngIf="journey.subscribed" class="w-px bg-gray-200 mx-1"></div>
          <button (click)="saveToggled.emit()"
            class="flex flex-col items-center gap-1 transition-colors text-[10px] uppercase font-bold"
            [ngClass]="saved ? 'text-primary' : 'text-gray-400 hover:text-gray-600'">
            <i class="text-base text-gray-500" [ngClass]="saved ? 'icon icon-bookmark-1' : 'icon icon-bookmark'"></i>
            <span class="text-gray-500 text-[10px] font-medium uppercase tracking-wide">{{ saved ? ('word-saved' |
              translate) : ('common.save' | translate) }}</span>
          </button>
        </div>

      </div>
    </div>

    <!-- Provider card -->
    <div class="mx-4 md:mx-0 mt-4 bg-white rounded-lg border border-border/50 shadow-md p-4 flex items-center gap-3">
      <div
        class="w-12 h-12 rounded-full bg-slate-50 flex items-center justify-center border border-gray-100 shadow-sm overflow-hidden flex-shrink-0">
        <img #journeyProviderImg *ngIf="getProviderLogoUrl()" [src]="getProviderLogoUrl()" alt="provider logo"
          class="max-w-[80%] max-h-[80%] object-contain"
          (error)="journeyProviderImg.style.display='none'; journeyProviderFallback.style.display='flex'">
        <span #journeyProviderFallback [style.display]="getProviderLogoUrl() ? 'none' : 'flex'"
          class="font-bold text-sm text-slate-400">
          {{ (journey?.provider?.name || company?.name || 'G').charAt(0).toUpperCase() }}
        </span>
      </div>
      <div>
        <span class="text-[10px] uppercase font-bold text-gray-700">{{'words.producted-by' | translate}}</span>
        <h5 class="text-sm font-normal text-gray-600">{{ journey?.provider?.name || company?.name }}</h5>
      </div>
    </div>

  </aside>

</div>